import { ApiResponse, TicketManagerTeam } from '@vision/ui/interfaces';

interface TicketManagerTeamResponseDto {
  id: string;
  name: string;
  project_id: string;
  user_ids?: string[];
}

export function normalizeTicketManagerTeam(dto: TicketManagerTeamResponseDto): TicketManagerTeam {
  return {
    id: dto.id,
    name: dto.name,
    projectId: dto.project_id,
    userIds: dto.user_ids,
  };
}

export function normalizeTicketManagerTeamsResponse(
  response: ApiResponse<TicketManagerTeamResponseDto[]>,
): ApiResponse<TicketManagerTeam[]> {
  return {
    ...response,
    data: response.data.map(normalizeTicketManagerTeam),
  };
}

export function normalizeTicketManagerTeamResponse(
  response: ApiResponse<TicketManagerTeamResponseDto>,
): ApiResponse<TicketManagerTeam> {
  return {
    ...response,
    data: normalizeTicketManagerTeam(response.data),
  };
}
